import * as actions from './maf-get.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiMafMethod } from 'src/app/api/api-methods.maf';
import { ContainerMafGetResponseI } from 'src/app/api/container-maf-get/container-maf-get-result.int';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingMafGet } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class ContainerMafGetEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);


    load$ = createEffect(() =>
        this.actions$.pipe(ofType(actions.load),
            mergeMap((params) => this.sharedGenericService.invoke(ApiMafMethod.mafiContainer, params.query).pipe(
                map((data: ContainerMafGetResponseI) =>  actions.received({
                    data,
                    pageType: params.pageType,
                })),
                catchError((error: SharedErrorObjectI) => [
                    actions.error({
                        messageText: error.message,
                        pageType: params.pageType,
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.messageText,
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => {
            return [
                spxSpinnerActions.hide({
                     action: loadingMafGet
                })
            ]
        }))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                 action: loadingMafGet
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                 action: loadingMafGet
            }),
        ]))
    );
}
